import { Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Sidebar } from '@/shared/components/layouts/Sidebar';
import { Header } from '@/shared/components/layouts/Header';
import { useUIStore } from '@/shared/stores/uiStore';
import { getPreferencesApi } from '@/features/auth/services/auth.api';
import { AiAssistantWidget } from '@/features/chat/components/AiAssistantWidget';

export function AppLayout() {
  const { sidebarOpen } = useUIStore();
  const { data: preferences } = useQuery({
    queryKey: ['preferences'],
    queryFn: getPreferencesApi,
    staleTime: 5 * 60 * 1000,
  });

  return (
    <div className="bg-mesh flex min-h-screen">
      <Sidebar />
      <div className={`ml-0 flex flex-1 flex-col transition-all ${sidebarOpen ? 'md:ml-64' : 'md:ml-16'}`}>
        <Header />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
      {preferences?.aiAssistantEnabled !== false && <AiAssistantWidget />}
    </div>
  );
}
